import { environment } from '../../../environments/environment';
import { CertificadoService } from './../../shared/service/certificado/certificado.service';
import { Injectable } from '@angular/core';
import { TourService } from 'ngx-tour-ngx-popper';

@Injectable()
export class TourInterativo {

    constructor(
        private certificadoService : CertificadoService,
        private tourService: TourService) {
    }

    getPassosTour() {
        this.buscaStatusFatores(() => { 
            this.definePassosTour();
        });
    }

    private statusFatores: any = {};

    private definePassosTour() {
        let isVarejo = false;
        let isAutenticacao = false;
        let steps: any[] = [];

        let host = location.host;
        if (host.startsWith('www.')) {
            host = host.substring(4);
        }

        isVarejo =  (localStorage.getItem('isVarejo') == "true");
       
        if ((!this.statusFatores.usuarioCadastrouPin) || (this.statusFatores.tokenOtpObrigatorio && !this.statusFatores.usuarioCadastrouTokenOtp)) {
          let next: any

          if (!this.statusFatores.usuarioCadastrouPin) {
            next = "stepId.AutenticacaoPin";
          }

          steps.push({
            stepId: 'stepId.Autenticacao',
            anchorId: 'tour.Autenticacao',
            content: 'Para emitir e utilizar o seu Certificado Digital, será necessário cadastrar o Pin'+ (this.statusFatores.tokenOtpObrigatorio ? ' e o e-Token.' : '.'),
            placement: 'right',
            title: 'Autenticação',
            route: 'fatores',
            prevBtnTitle: 'Anterior',
            nextBtnTitle: 'Próximo',
            endBtnTitle: 'Fim',
            nextStep: next
          });
          isAutenticacao = true;
        }
        
        if (!this.statusFatores.usuarioCadastrouPin)
        {
            steps.push({
                stepId: 'stepId.AutenticacaoPin',
                anchorId: 'tour.AutenticacaoPin',
                content: 'O Pin é uma senha somente para o uso do seu Certificado Digital, que poderá ser alterado a qualquer momento pelo titular do certificado. '+
                'Ao cadastrar o Pin serão apresentadas doze palavras, que deverão ser anotadas em local seguro. Caso necessite recuperar o Pin, as doze palavras serão solicitadas.',
                placement: 'bottom',
                title: 'Pin',
                prevBtnTitle: 'Anterior',
                nextBtnTitle: 'Próximo',
                endBtnTitle: 'Fim',
            });
        }
        
        if (this.statusFatores.tokenOtpObrigatorio && !this.statusFatores.usuarioCadastrouTokenOtp) {
          steps.push({
            stepId: 'stepId.AutenticacaoeToken',
            anchorId: 'tour.AutenticacaoeToken',
            content: 'O e-Token é um código temporário que é utilizado junto com o Pin para uso do Certificado Digital. '+
            'Para ter acesso ao e-Token é necessário fazer o download do aplicativo remoteID no seu smartphone ou adquirir o cartão.',
            placement: 'bottom',
            title: 'e-Token',
            prevBtnTitle: 'Anterior',
            nextBtnTitle: 'Próximo',
            endBtnTitle: 'Fim',
          });
        }
        
        if (!isVarejo){ 
          steps.push({
            stepId: 'stepId.SolicitarCertificadosCorporativo',
            anchorId: 'tour.SolicitarCertificadosCorporativo',
            content: 'Para solicitar o seu Certificado Digital, preencha os campos abaixo.',
            placement: 'right',
            prevStep: (isAutenticacao ? 'stepId.Autenticacao' : undefined),
            title: 'Solicitar Certificado',
            route: 'solicitar-certificado',
            prevBtnTitle: 'Anterior',
            nextBtnTitle: 'Próximo',
            endBtnTitle: 'Fim',
          });
        }

        this.tourService.events$.subscribe(console.log);
        this.tourService.initialize(steps);
    }

    private buscaStatusFatores(callback: () => void) {
        let idUsuario =  JSON.parse(localStorage.getItem("currentUser")).id;
        let idOrganizacao = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;

        this.certificadoService.getStatusFatores(idUsuario, idOrganizacao).subscribe(
            res => {
                this.statusFatores = res;
                callback();
            }
        );
    }
}